import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Paper, Typography, FormControl, IconButton, Container, FormControlLabel,
  Switch, Divider
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import { toastr } from 'react-redux-toastr';
import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle,
} from './styles';
import Spinner from '../../../components/Spinner';
import api from '../../../axios/api';

const TenantEditEquipmentFormMandatoryFields = () => {

  const { _id: tenantId, equipmentFormMandatoryFields } = useSelector(state => state.tenants.tenant);

  const [editMode, setEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [area, setArea] = useState(false);
  const [company, setCompany] = useState(false);
  const [serialNumber, setSerialNumber] = useState(false);
  const [brand, setBrand] = useState(false);
  const [description, setDescription] = useState(false);
  const [manufacturingDate, setManufacturingDate] = useState(false);
  const [reference, setReference] = useState(false);

  useEffect(() => {
    if (!equipmentFormMandatoryFields) return;
    setArea(equipmentFormMandatoryFields.area);
    setCompany(equipmentFormMandatoryFields.company);
    setSerialNumber(equipmentFormMandatoryFields.serialNumber);
    setBrand(equipmentFormMandatoryFields.brand);
    setDescription(equipmentFormMandatoryFields.description);
    setManufacturingDate(equipmentFormMandatoryFields.manufacturingDate);
    setReference(equipmentFormMandatoryFields.reference);
  }, [equipmentFormMandatoryFields])

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    const body = {
      equipmentFormMandatoryFields: {
        area,
        company,
        serialNumber,
        brand,
        description,
        manufacturingDate,
        reference,
      }
    }
    api.patch(`/tenants/${tenantId}/updateequipmentformmandatoryfields`, body)
      .then(() => {
        setLoading(false);
        toastr.success('Tenant Atualizado');
        setEditMode(false);
      })
      .catch(() => {
        setLoading(false);
        toastr.error('Erro ao atualizar o tenant')
      })
  }

  return (
    <Container maxWidth='sm' style={{ ...styles.container, opacity: loading ? 0.3 : 1 }}>
      {loading && <Spinner overlay />}
      <Paper style={{ marginBottom: 10 }}>
        <FormStyled onSubmit={handleSubmit}>
          <DivFormTitle>
            <Typography variant='h6'>Campos Obrigatórios Formulário de Equipamento</Typography>
            
            <DivSubmitButtons>
              {editMode ?
                <>
                  <IconButton onClick={() => setEditMode(false)} size="large"><CloseIcon color='error' /></IconButton>
                  <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
                </> :
                <>
                  <IconButton onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
                </>
              }
            </DivSubmitButtons>
            
          </DivFormTitle>
        <Divider />
        <div style={styles.switchsContainer}>       
          <FormControl variant="standard" margin='normal'>
            <FormControlLabel
              control={
                <Switch
                  disabled={!editMode}
                  name='area'
                  checked={area}
                  onChange={event => setArea(event.target.checked)}
                  color="primary"
                />
              }
              label="Departamento"
            />
          </FormControl>
          <FormControl variant="standard" margin='normal'>
            <FormControlLabel
              control={
                <Switch
                  disabled={!editMode}
                  name='company'
                  checked={company}
                  onChange={event => setCompany(event.target.checked)}
                  color="primary"
                />
              }
              label="Empresa"
            />
          </FormControl>
          <FormControl variant="standard" margin='normal'>
            <FormControlLabel
              control={
                <Switch
                  disabled={!editMode}
                  name='serialNumber'
                  checked={serialNumber}
                  onChange={event => setSerialNumber(event.target.checked)}
                  color="primary"
                />
              }
              label="Número de Série"
            />
          </FormControl>
          <FormControl variant="standard" margin='normal'>
            <FormControlLabel
              control={
                <Switch
                  disabled={!editMode}
                  name='brand'
                  checked={brand}
                  onChange={event => setBrand(event.target.checked)}
                  color="primary"
                />
              }
              label="Marca"
            />
          </FormControl>
          <FormControl variant="standard" margin='normal'>
            <FormControlLabel
              control={
                <Switch
                  disabled={!editMode}
                  name='description'
                  checked={description}
                  onChange={event => setDescription(event.target.checked)}
                  color="primary"
                />
              }
              label="Descrição"
            />
          </FormControl>
          <FormControl variant="standard" margin='normal'>
            <FormControlLabel
              control={
                <Switch
                  disabled={!editMode}
                  name='manufacturingDate'
                  checked={manufacturingDate}
                  onChange={event => setManufacturingDate(event.target.checked)}
                  color="primary"
                />
              }
              label="Data de Fabricação"
            />
          </FormControl>
          <FormControl variant="standard" margin='normal'>
            <FormControlLabel
              control={
                <Switch
                  disabled={!editMode}
                  name='reference'
                  checked={reference}
                  onChange={event => setReference(event.target.checked)}
                  color="primary"
                />
              }
              label="Referência"
            />
          </FormControl>
        </div>
        </FormStyled>
      </Paper>
    </ Container>
  );
};

export default TenantEditEquipmentFormMandatoryFields;

const styles = {
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    position: 'relative'
  },
  switchsContainer: {
    display: 'flex',
    flexDirection: 'column',
  }
}